import script from "./whr-home-project.vue?vue&type=script&setup=true&lang=js"
export * from "./whr-home-project.vue?vue&type=script&setup=true&lang=js"

import "./whr-home-project.vue?vue&type=style&index=0&id=ef16f4d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef16f4d8"]])

export default __exports__